import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * TemplateCard - Template card component for displaying template information
 * 
 * Features:
 * - Category badge with color coding
 * - Title and description
 * - View template link
 * - Hover effect with shadow
 * 
 * Design System:
 * - Border card with hover shadow
 * - Category badge with primary color
 * - Clean typography
 */
const TemplateCard = ({ category, title, description, onClick }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-xl transition-all duration-300">
      {/* Category Tag */}
      <div className="inline-block px-3 py-1 bg-primary-50 text-primary-700 text-xs font-semibold rounded-full mb-4">
        {category}
      </div>

      {/* Title */}
      <h3 className="text-lg font-bold text-gray-900 mb-3">
        {title}
      </h3>

      {/* Description */}
      <p className="text-sm text-gray-600 leading-relaxed mb-4">
        {description}
      </p>

      {/* Link */}
      <Link
        to="/templates"
        onClick={onClick}
        className="inline-flex items-center text-sm text-primary-600 hover:text-primary-700 font-semibold transition-colors"
      >
        Şablonu Görüntüle
        <span className="ml-1">→</span>
      </Link>
    </div>
  );
};

TemplateCard.propTypes = {
  category: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default TemplateCard;

